// extracted by mini-css-extract-plugin
export default {"root":"ghrNkOZk","suffix":"LPchTYAT","label":"vEby849g","feeLabel":"XPUDvAqg","feeConfirm":"SkacqSTU"};